<template>
	<div class="kd-header clearfix">
		<div class="kd-header-logo" @click="routeTo"><a>微信小程序路由代理服务中心</a></div>
		<!-- <div class="kd-header-toggle"><a class="iconfont icon-icon-move" :class="collapsed ? 'collapsed' : ''"
										 href="javascript:;" @click="handleCollapsed"></a></div> -->
		<div class="kd-header-btns">
			<a class="kd-h-user" title="用户">
				<el-dropdown trigger="click" @command="handleCommand">
                <span class="el-dropdown-link">
        	        <img :src="head" alt="">
					<span class="iconfont icon-pull down icon-icon-pulldown"></span>
                 </span>
					<el-dropdown-menu class="kd-header-dropdown" slot="dropdown">
						<!-- <el-dropdown-item command="a">个人中心</el-dropdown-item> -->
						<el-dropdown-item command="b">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</a>

		</div>
	</div>
</template>
<script>

	import head from '../../main/assets/img/icon-police.png';
	import Cookies from 'js-cookie';
	import loginServer from 'main/service/login';

	export default {
		props: {
			isCollapse: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				userId: '',
				headerSearch: null,
				collapsed: false,
				head: head
			};
		},
		mounted() {
			let winWidth = document.body.clientWidth||document.documentElement.clientWidth;
			if(winWidth <= 1440) {
				this.collapsed = true;
			}
		},
		methods: {
			routeTo() {
				this.$router.push({path: '/icmp/'});
			},
			// 点击个跳转个人中心 退出
			handleCommand(command) {
				if (command === 'a') {
					this.$router.push({path: '/icmp/personal-center'});
				} else if (command === 'b') {
					window.sessionStorage.removeItem('jwt_token');
					// 清除左边菜单相关数据
					window.sessionStorage.removeItem('menu_sign_array');
					window.sessionStorage.removeItem('button_sign_array');
					window.sessionStorage.removeItem('auth_menu_array');
					this.$router.push({path: '/login'});
				}
			},
			// 点击跳转到个人中心 ()
			routeLink() {
				this.$router.push({path: '/icmp/personal-center'});
			},
			handleCollapsed() {
				this.collapsed = !this.collapsed;
				this.$emit('getToggle', {isCollapse: this.collapsed});
			}
		}
	};
</script>
<style lang="scss">
	.kd-header {
		height: 60px;
		padding: 0 20px;
		background-color: #3860f4;
		box-shadow: 0 2px 4px 0 rgba(0,0,0,0.16);
	}

	.kd-header-logo {
		float: left;
		padding-left: 32px;
		font-size: 18px;
		line-height: 60px;
		height: 60px;
		font-weight: 400;
		color: #fff;
		cursor: pointer;
		min-width: 150px;
		background: url(../../main/assets/img/icon-logo.png) no-repeat 0 center;
		a {
			color: #fff;
			text-decoration: none;
			display:block;
		}
	}
	.kd-header-toggle {
		float: left;
		height: 18px;
		width: 16px;
		margin-top: 17px;
		a {
			display: inline-block;
			height: 18px;
			width: 16px;
			color: #fff;
			&.collapsed {
				margin-top:-2px;
				transition: all .2s ease;
				transform: rotate(90deg);
				-ms-transform: rotate(90deg); /* Internet Explorer */
				-moz-transform: rotate(90deg); /* Firefox */
				-webkit-transform: rotate(90deg); /* Safari 和 Chrome */
			}
		}
	}

	.kd-header-search {
		float: left;
		width: 320px;
		display: flex;
		height: 65px;
		align-items: center;
		.el-input__inner {
			background: #343237;
			border: none;
		}
	}

	.kd-header-btns {
		margin-right: 20px;
		float: right;
		a {
			display: block;
			float: left;
			height: 16px;
			margin-top: 17px;
			color: #fff;
			text-decoration: none;
		}
		.kd-h-notify {
			//background: url(../../main/assets/img/ppl-notify.png) no-repeat center center;
		}
		.kd-h-msg {
			margin-left: 20px;
		}
		.kd-h-user {
			.down {
				position: fixed;
				color: #ffffff;
				top: 25px;
				/* left: 5px; */
				right: 25px;
				font-size: 12px;
			}
			margin: 12px 5px 7px 20px;
			-webkit-border-radius: 50px;
			border-radius: 50px;
			width: 34px;
			height: 34px;
			img {
				width: 34px;
				height: 34px;
			}
		}
	}
	.kd-header-dropdown {
		.el-dropdown-menu__item:hover {
			color: #4B6DEA;
			background: #F0F4FC;
		}
	}
</style>



// WEBPACK FOOTER //
// components/kd-header/kd-header.vue